/* C06 · qt-hero.js — crossfade slider. Autoplay (section setting) stops permanently after any
   arrow/dot interaction (intended, C06). Arrows and dots follow the active slide's alignment.
   Editor: selecting a slide shows it and stops autoplay [P07]. Parallax via --qt-parallax-hero;
   none (and no autoplay, no video) under prefers-reduced-motion. Spec: 01-componenten.md C06. */
import { register, onScroll, prefersReducedMotion } from '@qt/core';

const state = new WeakMap();

function show(root, index) {
  const s = state.get(root);
  const count = s.slides.length;
  s.index = ((index % count) + count) % count;
  s.slides.forEach((slide, i) => {
    const active = i === s.index;
    slide.classList.toggle('is-active', active);
    slide.toggleAttribute('inert', !active);
    if (active) slide.removeAttribute('aria-hidden');
    else slide.setAttribute('aria-hidden', 'true');
  });
  s.dots.forEach((dot, i) => {
    dot.classList.toggle('is-active', i === s.index);
    if (i === s.index) dot.setAttribute('aria-current', 'true');
    else dot.removeAttribute('aria-current');
  });
  root.dataset.align = s.slides[s.index].dataset.align || 'left';
}

function stopAutoplay(root) {
  const s = state.get(root);
  clearInterval(s.timer);
  s.timer = null;
}

register('[data-qt-hero]', {
  init(root) {
    const slides = [...root.querySelectorAll('.qt-hero__slide')];
    if (!slides.length) return;
    const reduced = prefersReducedMotion();
    const s = { slides, dots: [...root.querySelectorAll('[data-hero-go]')], index: 0, timer: null, cleanups: [] };
    state.set(root, s);

    const onClick = (event) => {
      const step = event.target.closest('[data-hero-step]');
      const go = event.target.closest('[data-hero-go]');
      if (!step && !go) return;
      stopAutoplay(root); // permanently: the visitor has taken over
      show(root, step ? s.index + Number(step.dataset.heroStep) : Number(go.dataset.heroGo));
    };
    root.addEventListener('click', onClick);
    s.cleanups.push(() => root.removeEventListener('click', onClick));

    const seconds = Number(root.dataset.interval) || 6;
    if (root.dataset.autoplay === 'true' && slides.length > 1 && !reduced && !window.Shopify?.designMode) {
      s.timer = setInterval(() => show(root, s.index + 1), seconds * 1000);
    }

    if (reduced) root.querySelectorAll('.qt-hero__video').forEach((video) => video.pause());

    const strength = parseFloat(getComputedStyle(root).getPropertyValue('--qt-parallax-hero')) || 0;
    if (strength > 0 && !reduced) {
      const media = [...root.querySelectorAll('[data-qt-parallax]')];
      let frame = 0;
      s.cleanups.push(
        onScroll((top) => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            if (top > root.offsetTop + root.offsetHeight) return;
            media.forEach((el) => (el.style.transform = `translateY(${Math.round(top * strength)}px)`));
          });
        })
      );
    }
  },
  destroy(root) {
    const s = state.get(root);
    if (!s) return;
    stopAutoplay(root);
    s.cleanups.forEach((cleanup) => cleanup());
    state.delete(root);
  },
  select(root, block) {
    const s = state.get(root);
    if (!s) return;
    const index = s.slides.indexOf(block.closest('.qt-hero__slide') || block.querySelector('.qt-hero__slide'));
    stopAutoplay(root);
    if (index >= 0) show(root, index);
  },
});
